import React from 'react';
import { PropTypes } from 'prop-types';

import LoadingSpinnerIcon from '@icons/LoadingSpinnerIcon';
import colors from '@general/colors';
import { redirectToLogin } from '@general/redirectToLogin';
import Unauthorized from '../Unauthorized';

const UnauthorizedRedirect = ({ text }) => {
    setTimeout(() => {
        redirectToLogin();
    }, 100);

    return (
        <Unauthorized activeOnly text={text}>
            <h5 className="mt-3" style={{ fontSize: '1rem' }}>
                <LoadingSpinnerIcon size="lg" fill={colors.darkGray} /> Redirecting
            </h5>
        </Unauthorized>
    );
};

UnauthorizedRedirect.propTypes = {
    text: PropTypes.string,
};

export default UnauthorizedRedirect;
